import React from 'react';
import coreMap from 'gatsby-theme-pagebuilder/src/components/blocks/static/static-mapping';
import WordpressBlogs from '../../../../components/pagebuilder/latest-wordpress-blogs';
import PromoCalldrip from '../../../../components/pagebuilder/promo-calldrip';
import PartnersLogos from '../../../../components/pagebuilder/partners-logos/index';
import AllPartners from '../../../../components/pagebuilder/all-partners';

const Todo = ({ name }) => {
  console.warn('todo, static block ', name);
  return null;
};

export default {
  ...coreMap,
  wordpress_blogs: WordpressBlogs,
  promo_calldrip: PromoCalldrip,
  Partners_logos: PartnersLogos,
  All_partners: AllPartners,
  Socialmedia: () => <Todo name="Socialmedia" />,
  Partners_logos_slider: () => <Todo name="Partners_logos_slider" />,
  Seminar_reviews: () => <Todo name="Seminar_reviews" />,
  Presentaties_reviews: () => <Todo name="Presentaties_reviews" />,
  Upcoming_events: () => <Todo name="Upcoming_events" />,
  All_upcoming_events: () => <Todo name="All_upcoming_events" />,
  All_past_events: () => <Todo name="All_past_events" />,
  WooCommerce_products: () => <Todo name="WooCommerce_products" />,
  ROI_Portals: () => <Todo name="ROI_Portals" />,
  PDV_Header: () => <Todo name="PDV_Header" />,
  Paul_calldrip_quote: () => <Todo name="Paul_calldrip_quote" />,

};
